export const createH1 = (str) => `# ${str}`;
